/**
 * our harriApp passed to the function
 *
 * @type {Object} harriApp
 * @namespace AtWho
 */
(function (app) {
    "use strict";

    /**
     * This is the wrapper for At.js plugin that added to our project using bower.js
     *
     * @constructor
     */
    var AtWho = function () {
        var self = this;

        /**
         * The element need to attach At.js with it passed from draw function
         *
         * @private
         * @param {Node, jQuery}
         * @name AtWho#element
         */
        var element;

        /**
         * The At.js options passed from draw function
         *
         * @private
         * @type {{callbacks: Object}}
         * @name AtWho#options
         */
        var options = {};

        /**
         * To check if the plugin attached to the dom or not
         *
         * @private
         * @type {Boolean}
         * @name AtWho#initialized
         */
        var initialized;

        /**
         * These our callbacks passed to this wrapper
         *
         * @private
         * @type {Object}
         * @name AtWho#harriCallbacks
         */
        var harriCallbacks;

        /**
         * Dom event listener to handle any changes on the content editable div
         *
         * @private
         * @type {DomMutationObserver}
         * @name AtWho#domEventChangesListener
         */
        var domEventChangesListener = new YDomMutationObserver();

        /**
         * Return harri events to handle smart-field component
         *
         * @param {Object} harriOptions
         * @param {Function} harriOptions.focusout
         * @param {Function} harriOptions.domChanged
         * @returns {Object} needed callbacks for harri
         * @private
         * @type {Function[]}
         */
        var DEFAULT_HARRI_CALLBACKS = function (harriOptions) {
            /**
             * Events handlers
             *
             * @name DEFAULT_HARRI_CALLBACKS#handlers
             * @type Object
             */
            var callbacks = {};

            /**
             * Handle focusout when the user focus out from element
             *
             * @param e
             */
            callbacks.focusout = function (e) {
                harriOptions.focusout(e);
            };

            /**
             * This is the event triggered when the browser said the dom are changed
             * This to make sure that the model updated every time and make sure that appended elements are editable true
             * because Android devices hide the keyboard when the element is not editable
             *
             * @param {MutationRecord} records
             * @type {Function[]}
             */
            var toRef = null;
            var lockToRef = null;
            callbacks.domChanged = function (records) {
                harriOptions.lockChanges(true);
                window.clearTimeout(toRef);
                window.clearTimeout(lockToRef);
                toRef = window.setTimeout(function(){
                    for (var i in records) {
                        var record = records[i] || {};
                        if (record.target && !record.target.isContentEditable && $(record.target).hasClass('atwho-inserted')) {
                            $(record.target).attr('contenteditable', true);
                        }
                    }
                    lockToRef = setTimeout(function () {
                        harriOptions.lockChanges(false);
                    }, 10);
                    harriOptions.domChanged(records);
                }, 200);
            };

            return callbacks;
        };

        /**
         * The At.js default functions callback that needed to passed to it all time
         * you can override any of these functions
         *
         * @param harriOptions
         * @param {String} harriOptions.leftBrackets
         * @param {String} harriOptions.rightBrackets
         *
         * @returns {
         *       {
         *          beforeSave: Function,
         *          matcher: Function,
         *          filter: Function,
         *          sorter: Function,
         *          tplEval: Function,
         *          highlighter: Function,
         *          beforeInsert: Function,
         *          beforeReposition: Function,
         *          afterMatchFailed: Function
         *       }
         * }
         *
         * @private
         * @type {Function[]}
         */
        var DEFAULT_CALLBACKS = function (harriOptions) {
            return {
                /**
                 * this function called to restructure your own data
                 * @param data
                 * @returns {Array}
                 */
                beforeSave: function (data) {
                    var results = [];

                    if (!Array.isArray(data)) {
                        throw new Error('On before save callback data must be array from first', Date.now());
                    }

                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];

                        if (jQuery.isPlainObject(item)) {
                            results.push(item);
                        } else {
                            var convertItem = {};
                            convertItem[options.searchKey] = item;

                            results.push(convertItem);
                        }
                    }

                    return results;
                },
                /**
                 * It would be called to match the `flag`.
                 * It will match at start of line or after whitespace
                 * this is the function decide if the user enter the character for auto complete or not
                 * after detect the character the filter function called
                 *
                 * @param flag
                 * @param subtext
                 * @param shouldStartWithSpace
                 * @param acceptSpaceBar
                 * @returns {null}
                 */
                matcher: function (flag, subtext, shouldStartWithSpace, acceptSpaceBar) {
                    flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

                    if (shouldStartWithSpace) {
                        flag = '(?:^|\\s)' + flag;
                    }

                    // latin characters
                    // ÿ, À used on regular expression
                    var _a = decodeURI("%C3%80");
                    var _y = decodeURI("%C3%BF");

                    var space = acceptSpaceBar ? "\ " : "";

                    var regexp = new RegExp(flag + "([A-Za-z" + _a + "-" + _y + "0-9_" + space + "\'\.\+\-]*)$|" + flag + "([^\\x00-\\xff]*)$", 'gi');
                    var match = regexp.exec(subtext);

                    return match? (match[2] || match[1]) : null;
                },
                /**
                 * called after the matcher function return value for the query
                 * the value for this is the match on the matcher function
                 *
                 * @param query
                 * @param data
                 * @param searchKey
                 * @returns {Array}
                 */
                filter: function(query, data, searchKey) {
                    var results = [];

                    if (!Array.isArray(data)) {
                        throw new Error('This is filter function the data not parsed as well on before save function its not an array', Date.now());
                    }

                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        var searchItem = String(item[searchKey]);

                        if (searchItem.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                            results.push(item);
                        }
                    }

                    return results;
                },
                /**
                 * this to sort the data for what the user enter on the inputs
                 * we can change how the sorter function work here
                 *
                 * @param query
                 * @param items
                 * @param searchKey
                 * @returns {Array}
                 */
                sorter: function(query, items, searchKey) {

                    if (!query) {
                        return items;
                    }

                    var results = [];

                    for (var i = 0; i < items.length; i++) {
                        var item = items[i];
                        var searchItem = String(item[searchKey]);

                        item.order = searchItem.toLowerCase().indexOf(query.toLowerCase());

                        if (item.order > -1) {
                            results.push(item);
                        }
                    }

                    var _sorter = function(a, b) {
                        return a.order - b.order;
                    };

                    return results.sort(_sorter).map(function(item){
                        // keep the order attribute will cause the draw function
                        // to rerender as it will change the attribute
                        delete item.order;
                        return item;
                    });
                },
                /**
                 * this function used to eval two steps
                 * the first step is to eval the value on li list as 'pop-up-item-template' on our component
                 * for example: pop-up-item-template="'<li>${name}</li>'"
                 * replace ${name} by its own value
                 * the second step is to eval the entered value after the user choose one option
                 * for example: insert-item="'${code}'"
                 * tpl is the string template
                 * map is the data we passed after filter it on the filter function
                 * you can pass the insert-item and pop-up-item-template as function
                 *
                 *
                 * @param template
                 * @param map
                 * @returns {String}
                 */
                tplEval: function(template, map) {

                    if (typeof template === 'function') {
                        return template(map);
                    } else if (typeof template === 'string') {
                        return template.replace(/\$\{([^\}]*)\}/g, function(tag, key, pos) {
                            return '<span data-content-code="' + map[harriOptions.insertedKey] + '">' + map[key] + '</span>';
                        });
                    } else {
                        throw new Error('on template eval function the template can be function or string as ${value}', Date.now());
                    }
                },
                /**
                 * this function to highlight the matched index of value on the pop up list
                 * shown under the word
                 *
                 * @param li
                 * @param query
                 * @returns {String}
                 */
                highlighter: function(li, query) {
                    if (!query) {
                        return li;
                    }

                    var regexp = new RegExp(">\\s*([^\<]*?)(" + query.replace("+", "\\+") + ")([^\<]*)\\s*<", 'ig');

                    return li.replace(regexp, function(str, $1, $2, $3) {
                        return '> ' + $1 + '<strong>' + $2 + '</strong>' + $3 + ' <';
                    });
                },
                /**
                 * This function called before insert value on the editable content
                 * by default its span with atwho-inserted class
                 * i added another span inside it with harri class called 'highlight-selected-value'
                 *
                 * @param value
                 * @param $li
                 * @param e
                 * @returns {string}
                 */
                beforeInsert: function(value, $li, e) {
                    var leftBrackets = harriOptions.leftBrackets || '{{';
                    var rightBrackets = harriOptions.rightBrackets || '}}';

                    var insertedHtml = '<span class="highlight-selected-value">';
                    insertedHtml += '<span class="left-brackets ' + ((harriOptions.hideBrackets) ? 'hidden' : '') + '">' + leftBrackets + '</span>';
                    insertedHtml += value;
                    insertedHtml += '<span class="right-brackets ' + ((harriOptions.hideBrackets) ? 'hidden' : '') + '">' + rightBrackets + '</span>';
                    insertedHtml += '</span>';

                    return insertedHtml;
                },
                beforeReposition: function(offset) {
                    return offset;
                },
                afterMatchFailed: function(at, el) {}
            };
        };

        /**
         * This to hide the smart-field auto complete when clicking out side the element
         * This action attached to the body dom
         *
         * @private
         * @param e
         * @name AtWho#handleDocumentClick
         */
        var handleDocumentClick = function (event) {

            if (
                element && !element.is(':focus')
            ) {
                element.find('.atwho-query').remove();
                element.atwho('hide');
            }
        };

        /**
         * This events attached for the element.
         * The first one is focus out
         * The second one is dom change event
         *
         * @private
         * @param harriOptions
         * @name AtWho#handleElementEvents
         */
        var handleElementEvents = function (harriOptions) {
            harriCallbacks = DEFAULT_HARRI_CALLBACKS(harriOptions);

            /**
             * Listen to focusout event with namespace as smart-fields.scss
             */
            element.on('focusout.smart-fields', harriCallbacks.focusout);

            /**
             * These params used on MutationObserver
             * At the very least, childList, attributes, or characterData must be set to true.
             */
            var domEventOptions = {
                attributes: false,
                characterData: true,
                childList: true,
                subtree: true,
                attributeOldValue: false,
                characterDataOldValue: false
            };

            /**
             * This to send the element to this component as dom element with its options
             */
            domEventChangesListener.init(element[0], domEventOptions);

            /**
             * The dom events handler all of them call the domChanged API
             */
            domEventChangesListener.on(YDomMutationObserver.EVENTS.ON_CHARACTER_DATA_CHANGED, harriCallbacks.domChanged);
            domEventChangesListener.on(YDomMutationObserver.EVENTS.ON_CHILD_LIST_CHANGED, harriCallbacks.domChanged);
            domEventChangesListener.on(YDomMutationObserver.EVENTS.ON_CHANGE, harriCallbacks.domChanged);

            /**
             * After attach the needed events start listening to dom changes
             */
            domEventChangesListener.startListening(500);

            /**
             * @private
             * @type {*|jQuery|HTMLElement}
             */
            var body = $('body');

            /**
             * Attach hide smart-field body event
             */
            body.on('click.smart-fields', handleDocumentClick);
        };

        /**
         * Used to draw the element and attach events to it and check if the element have the plugin or not
         * Then send options to plugin and start working
         *
         * @param {*|jQuery|HTMLElement} elementAttached
         * @param {Object} atWhoOptions
         * @param {Object} harriOptions
         */
        self.draw = function (elementAttached, atWhoOptions, harriOptions){

            /**
             * make sure to hard copy the options getting from outside then check if the options are changed then
             * initialize the element another time
             */
            var checkOptions = jQuery.extend(true, {}, options);
            delete checkOptions.callbacks;

            if (
                JSON.stringify(atWhoOptions) !== JSON.stringify(checkOptions) ||
                harriOptions.disabledField
            ) {
                initialized = false;

                if (element) {
                    element.atwho('destroy');
                }
            }

            /**
             * Check if the component initialized or not and if its disabled no need to initialize
             */
            if (!initialized && !harriOptions.disabledField) {
                options = jQuery.extend(true, {}, atWhoOptions);
                harriOptions = jQuery.extend(true, {}, harriOptions);

                if (!elementAttached) {
                    throw new Error('Element not send with options to attach the at who with id', Date.now());
                }

                element = elementAttached;

                /**
                 * handle events for the editable content area
                 */
                handleElementEvents(harriOptions);

                /**
                 * extend callbacks
                 */
                var callbacks = jQuery.extend(true, {}, harriOptions.callbacks);
                var atWhoCallbacks = {};

                /**
                 * mapping our callbacks with at who callbacks
                 */
                var atWhoCallbacksMapping = {
                    /**
                     * change your data shape
                     */
                    onChangeDataShape: 'beforeSave',
                    /**
                     * get the value after character like @value
                     * onMatchingValue must return value
                     */
                    onMatchingValue: 'matcher',
                    /**
                     * after get the match value start filter the value
                     */
                    onFilterValues: 'filter',
                    /**
                     * sort the result shown on pop up
                     */
                    onSortPopupValues: 'sorter',
                    /**
                     * eval string if you pass it as template like ${name}
                     */
                    onTemplateEval: 'tplEval',
                    /**
                     * highlight the matched index of value on the pop up list
                     */
                    onHighlightTextOnPopup: 'highlighter',
                    /**
                     * this function called before insert value on the editable content
                     */
                    onBeforeInsert: 'beforeInsert',
                    onBeforeReposition: 'beforeReposition',
                    onMatchFailed: 'afterMatchFailed'
                };

                /**
                 * map our callbacks with at who callbacks as shown on atWhoCallbacksMapping object
                 */
                for (var i in atWhoCallbacksMapping) {
                    var mapping = atWhoCallbacksMapping[i];

                    if (callbacks[i]) {
                        atWhoCallbacks[mapping] = callbacks[i];
                    }
                }

                var atWhoDefaultCallbacks = DEFAULT_CALLBACKS(harriOptions);

                options.callbacks = jQuery.extend(true, {}, atWhoDefaultCallbacks, atWhoCallbacks);

                /**
                 * handle at who attach to dom element
                 */
                element.atwho('destroy');
                setTimeout(function(){
                    element.atwho(options);
                });
                /**
                 * To handle if the element attach atWho with it or not
                 *
                 * @type {boolean}
                 */
                initialized = true;
            }
        };

        /**
         * @returns {*|jQuery|HTMLElement}
         */
        self.getElement = function () {
            return element;
        };

        /**
         * @returns {{callbacks: Object}}
         */
        self.getOptions = function () {
            return options;
        };

        /**
         * @return html
         */
        self.getHtml = function () {
            return element.html();
        };

        /**
         * Needs to get the value for the editable content as string without any span or html elements
         * and replace name by codes
         *
         * @return string for model value
         */
        self.getValue = function (leftBrackets, rightBrackets) {
            var getEditContent = function (html) {
                var ce = $("<pre />").html(html);

                var isStringEmpty = function(str) {
                    return str.length === 0 || str === " " || /^\s*$/.test(str);
                };

                if (/chrome/.test(navigator.userAgent.toLowerCase()) || /safari/.test(navigator.userAgent.toLowerCase())) {
                    ce.html(ce.html().replace(/\n/g, ' '));
                    ce.find('br').remove();

                    var i = 0;

                    ce.find("div").replaceWith(function() {
                        if (!isStringEmpty($(this).text())) {
                            var returnData = $(this).text() + '\n';

                            if (i === 0) {
                                returnData = ('\n' + returnData);
                            }

                            i++;
                            return returnData;
                        }

                        i++;

                        return '\n';
                    });
                } else if (!!navigator.userAgent.match(/MSIE/) || !!navigator.userAgent.match(/Trident\/7.0/)) {
                    ce.html(ce.html().replace(/\n/g, ' '));
                    ce.find('br').remove();

                    var i = 0;

                    ce.find("p").replaceWith(function() {
                        if (!isStringEmpty($(this).text())) {
                            var returnData = $(this).text() + '\n';

                            if (i === 0) {
                                returnData = ('\n' + returnData);
                            }

                            i++;
                            return returnData;
                        }

                        return '\n';
                    });
                } else {
                    ce.html(ce.html().replace(/\n/g, ' '));
                    ce.find("br").replaceWith('\n');
                }

                return ce.text().trim();
            };

            var newElement = element.clone();
            var codes = newElement.find('[data-content-code]');

            codes.each(function (index, codeElement) {
                var _element = $(codeElement);
                var _code = $(_element).data('contentCode');
                var _code_parent = _element.parents('.highlight-selected-value');

                leftBrackets = leftBrackets || '{{';
                rightBrackets = rightBrackets || '}}';

                _code_parent.find('.left-brackets').remove();
                _code_parent.find('.right-brackets').remove();

                _element.text(leftBrackets + _code + rightBrackets);
            });

            return Utils.escapeHtml(getEditContent(newElement.html()));
        };

        /**
         * Destroy the element and remove any handlers added to dom without remove it
         */
        self.destroy = function () {
            options = {};
            element && element.atwho('destroy');

            var body = $('body');
            body.off('click.smart-fields', handleDocumentClick);
            body.find('.atwho-container').remove();

            element = null;
            initialized = false;

            domEventChangesListener.destroy();
        };
    };

    /**
     * This to return instance from AtWho
     *
     * @constructor
     */
    var AtWhoWrapper = function () {

        var Public = {};
        var Instance;

        /**
         * @returns {AtWho}
         */
        Public.getInstance = function () {
            return Instance = new AtWho();
        };

        return Public;
    }();

    /**
     * @typedef {Object} AtWhoWrapperComponentController
     * Smart-fields component controller
     */

    /**
     * Construct a new AtWhoWrapperComponentController
     * @param $scope
     * @param $element
     * @constructor
     * @private
     */
    var AtWhoWrapperComponentController = function ($scope, $element, $timeout, $sce, $sanitize) {
        var self = this;
        self.name = self.name || self.hName;
        /**
         * @name AtWhoWrapperComponentController#isDestroyed
         * @type {boolean}
         * @private
         */
        var isDestroyed;

        /**
         * @name AtWhoWrapperComponentController#atWhoWrapper
         * @type {AtWho}
         * @private
         */
        var atWhoWrapper;

        /**
         * @name AtWhoWrapperComponentController#atWhoOptions
         * @type {{
         *    at: String,
         *    alias: String,
         *    data: Array,
         *    displayTpl: String,
         *    insertTpl: String,
         *    headerTpl: String,
         *    callbacks: Object,
         *    functionOverrides: Object,
         *    searchKey: String,
         *    suffix: String,
         *    hideWithoutSuffix: Boolean,
         *    startWithSpace: Boolean,
         *    acceptSpaceBar: Boolean,
         *    highlightFirst: Boolean,
         *    limit: Number,
         *    maxLen: Number,
         *    minLen: Number,
         *    displayTimeout: Number,
         *    delay: Number,
         *    spaceSelectsMatch: Boolean,
         *    tabSelectsMatch: Boolean,
         *    editableAtwhoQueryAttrs: Object,
         *    scrollDuration: Number,
         *    suspendOnComposing: Number,
         *    lookUpOnClick: Boolean
         * }}
         * @private
         */
        var atWhoOptions = {};

        /**
         * default harri options as shown on at who code
         * These attributes not all used these just to give short show what we used here
         * @private
         */
        var harriOptions = {
            character: '@',
            class: '',
            data: null,
            dataAttributes: null,
            delay: null,
            displayTimeout: 300,
            hideWithoutSuffix: undefined,
            highlightFirst: true,
            insertItem: '${your_own_shown_attribute}',
            isTextArea: false,
            itemsLimit: 5,
            maxLen: 20,
            name: null,
            popUpItemTemplate: '<li>${your_own_shown_attribute_on_your_object}</li>',
            popupHeader: null,
            searchKey: 'your_own_searchable_attribute_on_your_object',
            startWithSpace: true,
            suffix: undefined,
            leftBrackets: '{{',
            rightBrackets: '}}',
            insertedKey: 'code'
        };

        /**
         * Element created on this component
         *
         * @private
         * @param {Node, jQuery}
         * @name AtWhoWrapperComponentController#element
         * @private
         */
        var element;

        /**
         * Random id using timestamp
         *
         * @type {null, string}
         * @private
         */
        var id = 'smart-field-' + Date.now();

        /**
         * Starting point for this component
         * @private
         */
        var onInit = function () {
            atWhoWrapper = atWhoWrapper || AtWhoWrapper.getInstance();

            element = $element.find('.editable-content');
            element.attr('id', id);

            var harriCopyOptions = jQuery.extend(true, {}, harriOptions);

            /**
             * Update model on parent scope using onModelChanged Events
             * @private
             */
            var ngModelChanged = function () {
                var newValue = atWhoWrapper.getValue(harriCopyOptions.leftBrackets, harriCopyOptions.rightBrackets);
                var modelValue = self.ngModel || "";

                if (modelValue !== newValue) {
                    self.ngModel = newValue;
                    self.onModelChanged({value: newValue});
                }
            };

            /**
             * @return input element to trigger the validation when needed
             */
            var getInputField = function () {
                var inputField = 'textarea';

                if (!harriCopyOptions.isTextArea) {
                    inputField = 'input';
                }

                return element.parents('.smart-fields').find(inputField + '[name="' + self.name + '"]');
            };

            /**
             * editable content events
             * this to sync hidden fields with model values using ng-model
             *
             * @param e
             */
            harriCopyOptions.focusout = function (e) {
                var field = getInputField();
                field.trigger('change');
            };

            /**
             * DOM change event
             *
             * @param records
             */
            harriCopyOptions.domChanged = function (records) {
                ngModelChanged();
            };

            harriCopyOptions.lockChanges = function (lock) {
                self.lockChanges = lock;
            };

            /**
             * @type {*|string}
             */
            var model = self.ngModel || '';

            /**
             * Start fill the model on the content editable div
             */
            if (model) {
                var rightBrackets = harriCopyOptions.rightBrackets;
                var leftBrackets = harriCopyOptions.leftBrackets;

                /**
                 * Get all lines on the string to converted to div or p or br
                 * @type {Array}
                 */
                model = model.split(/\n/g);

                var isStringEmpty = function(str) {
                    return str.length === 0 || str === " " || /^\s*$/.test(str);
                };

                for (var i in model) {
                    if (/chrome/.test(navigator.userAgent.toLowerCase()) || /safari/.test(navigator.userAgent.toLowerCase())) {
                        model[i] = "<div>" + (isStringEmpty(model[i]) ?  '<br />' : model[i]) + "</div>";
                    } else if (!!navigator.userAgent.match(/MSIE/) || !!navigator.userAgent.match(/Trident\/7.0/)) {
                        model[i] = "<p>" + model[i] + "</p>";
                    } else {
                        model[i] = model[i] + "<br />";
                    }
                }

                model = model.join('');

                /**
                 * Get all elements inside {{ }} on the string to replace it with write data
                 * The replace is using the insertedKey options
                 * @type {Array}
                 */
                var matchedData = model.match(new RegExp(leftBrackets+'.+?'+rightBrackets, 'g')) || [];
                var data = self.data || [];

                /**
                 * Loop through the smart-field inside this component
                 */
                for (var i in matchedData) {
                    var match = matchedData[i];

                    /**
                     * Replace the brackets between each smart-field by empty to attach them to view to show
                     * them as smart-fields wrapped by span with blue color
                     */
                    match = match.replace(rightBrackets, '');
                    match = match.replace(leftBrackets, '');

                    /**
                     * Get the code value from the data and attach them to the view
                     * Example: {BRAND_NAME} replaced by Brand Name and set the BRAND_NAME on the span as
                     * data-content-code="BRAND_NAME" to replace it when save the model value
                     */
                    var codeValue;

                    /**
                     * To get the code from send data
                     */
                    for (var j in data) {
                        var item = data[j];

                        if (item[harriCopyOptions.insertedKey] && (item[harriCopyOptions.insertedKey]+"").toLowerCase() === match.toLowerCase()) {
                            codeValue = match;
                            match = item[atWhoOptions.searchKey];
                            break;
                        }
                    }

                    /**
                     * Replace code by name then attache it to view model
                     */
                    if (codeValue) {
                        var insertedValue = '';

                        if (!harriCopyOptions.disabledField) {
                            insertedValue = '<span class="atwho-inserted" data-atwho-at-query="' + atWhoOptions.at + '" contenteditable="true">';
                        }

                        insertedValue += '<span class="highlight-selected-value">';
                        insertedValue += '<span class="left-brackets ' + ((harriOptions.hideBrackets) ? 'hidden' : '') + '">' + leftBrackets + '</span>';
                        insertedValue += '<span data-content-code="' + codeValue + '">' + match + '</span>';
                        insertedValue += '<span class="right-brackets ' + ((harriOptions.hideBrackets) ? 'hidden' : '') + '">' + rightBrackets + '</span>';
                        insertedValue += '</span>';

                        if (!harriCopyOptions.disabledField) {
                            insertedValue += '</span>';
                        }

                        model = model.replace(matchedData[i], insertedValue);
                    }
                }
            }



            /**
             * Stop click event on searchable content
             *
             * @type {boolean}
             */
            atWhoOptions.lookUpOnClick = false;

            /**
             * Draw element
             */
            atWhoWrapper.draw(element, atWhoOptions, harriCopyOptions);


            /**
             * Get the element to check if its rendered or not to update the html value on it
             * It shows as work around to not update the div element when the model is equal to the old value
             * because the onInit function called every time the model changed, but we don't need to updated when
             * its updated inside this component
             *
             * @type {*|jQuery|HTMLElement}
             * @private
             */
            var _ele = atWhoWrapper.getElement();

            if (_ele) {
                var nowHtml = atWhoWrapper.getValue(harriCopyOptions.leftBrackets, harriCopyOptions.rightBrackets) || '';

                if (!model) {
                    element.empty();
                } else if (nowHtml.trim() !== self.ngModel.trim()) {
                    element.html(model);
                }
            } else {
                element.html('');
            }

        };


        /**
         * Called on each controller after all the controllers on an element
         * Get needed options for this component
         *
         * @type {Function[]}
         */
        self.$onInit = function () {

            if (typeof (self.character) !== 'undefined') {
                atWhoOptions.at = self.character;
            }

            if (typeof (self.data) !== 'undefined') {
                atWhoOptions.data = angular.copy(self.data);
            }

            if (typeof (self.popupHeader) !== 'undefined') {
                atWhoOptions.headerTpl = self.popupHeader;
            }

            if (typeof (self.popUpItemTemplate) !== 'undefined') {
                atWhoOptions.displayTpl = self.popUpItemTemplate;
            }

            if (typeof (self.insertItem) !== 'undefined') {
                atWhoOptions.insertTpl = self.insertItem;
            }

            if (typeof (self.searchKey) !== 'undefined') {
                atWhoOptions.searchKey = self.searchKey;
            }

            if (typeof (self.itemsLimit) !== 'undefined') {
                atWhoOptions.limit = self.itemsLimit;
            }

            if (typeof (self.maxLen) !== 'undefined') {
                atWhoOptions.maxLen = self.maxLen;
            }

            if (typeof (self.startWithSpace) !== 'undefined') {
                atWhoOptions.startWithSpace = self.startWithSpace;
            }

            if (typeof (self.displayTimeout) !== 'undefined') {
                atWhoOptions.displayTimeout = self.displayTimeout;
            }

            if (typeof (self.highlightFirst) !== 'undefined') {
                atWhoOptions.highlightFirst = self.highlightFirst;
            }

            if (typeof (self.delay) !== 'undefined') {
                atWhoOptions.delay = self.delay;
            }

            if (typeof (self.suffix) !== 'undefined') {
                atWhoOptions.suffix = self.suffix;
            }

            if (typeof (self.hideWithoutSuffix) !== 'undefined') {
                atWhoOptions.hideWithoutSuffix = self.hideWithoutSuffix;
            }

            if (typeof (self.dataAttributes) === 'object') {
                atWhoOptions.editableAtwhoQueryAttrs = self.dataAttributes;
            }

            if (typeof (self.callbacks) === 'object') {
                harriOptions.callbacks = self.callbacks;
            }

            if (typeof (self.isTextArea) !== 'undefined') {
                harriOptions.isTextArea = self.isTextArea;
            }

            if (typeof (self.leftBrackets) !== 'undefined') {
                harriOptions.leftBrackets = self.leftBrackets;
            }

            if (typeof (self.rightBrackets) !== 'undefined') {
                harriOptions.rightBrackets = self.rightBrackets;
            }

            if (typeof (self.hideBrackets) !== 'undefined') {
                harriOptions.hideBrackets = self.hideBrackets;
            }

            if (typeof (self.insertedKey) !== 'undefined') {
                harriOptions.insertedKey = self.insertedKey;
            }

            if (typeof (self.disabledField) !== 'undefined') {
                harriOptions.disabledField = self.disabledField;
            }

            if (
                Object.keys(atWhoOptions).length &&
                atWhoOptions.data &&
                atWhoOptions.data.length
            ) {
                onInit();
            }
        };

        /**
         * Called whenever one-way bindings are updated
         *
         * @type {Function[]}
         * @param changes
         * @param {String} changes.character
         * @param {Array} changes.data
         * @param {Array} changes.data
         * @param {String} changes.popupHeader
         * @param {String} changes.popUpItemTemplate
         * @param {String} changes.insertItem
         * @param {String} changes.searchKey
         * @param {String} changes.searchKey
         * @param {Number} changes.itemsLimit
         * @param {Number} changes.maxLen
         * @param {Boolean} changes.startWithSpace
         * @param {Boolean} changes.displayTimeout
         * @param {Boolean} changes.highlightFirst
         * @param {Boolean} changes.delay
         * @param {String} changes.suffix
         * @param {Boolean} changes.hideWithoutSuffix
         * @param {Object} changes.dataAttributes
         * @param {Object} changes.callbacks
         * @param {Boolean} changes.isTextArea
         * @param {Boolean} changes.disabledField
         * @param {String} changes.leftBrackets
         * @param {String} changes.rightBrackets
         * @param {Boolean} changes.hideBrackets
         * @param {String} changes.insertedKey
         * @param {Object} changes.ngModel
         */
        self.$onChanges = function (changes) {
            var newOptions = {};

            if (
                typeof (changes.character) !== 'undefined' &&
                !changes.character.isFirstChange() &&
                JSON.stringify(changes.character.currentValue) !== JSON.stringify(changes.character.previousValue)
            ) {
                newOptions.at = changes.character.currentValue;
            }

            if (
                typeof (changes.data) !== 'undefined' &&
                !changes.data.isFirstChange() &&
                JSON.stringify(changes.data.currentValue) !== JSON.stringify(changes.data.previousValue)
            ) {
                newOptions.data = angular.copy(changes.data.currentValue);
            }

            if (
                typeof (changes.popupHeader) !== 'undefined' &&
                !changes.popupHeader.isFirstChange() &&
                JSON.stringify(changes.popupHeader.currentValue) !== JSON.stringify(changes.popupHeader.previousValue)
            ) {
                newOptions.headerTpl = changes.popupHeader.currentValue;
            }

            if (
                typeof (changes.popUpItemTemplate) !== 'undefined' &&
                !changes.popUpItemTemplate.isFirstChange() &&
                JSON.stringify(changes.popUpItemTemplate.currentValue) !== JSON.stringify(changes.popUpItemTemplate.previousValue)
            ) {
                newOptions.displayTpl = changes.popUpItemTemplate.currentValue;
            }

            if (
                typeof (changes.insertItem) !== 'undefined' &&
                !changes.insertItem.isFirstChange() &&
                JSON.stringify(changes.insertItem.currentValue) !== JSON.stringify(changes.insertItem.previousValue)
            ) {
                newOptions.insertTpl = changes.insertItem.currentValue;
            }

            if (
                typeof (changes.searchKey) !== 'undefined' &&
                !changes.searchKey.isFirstChange() &&
                JSON.stringify(changes.searchKey.currentValue) !== JSON.stringify(changes.searchKey.previousValue)
            ) {
                newOptions.searchKey = changes.searchKey.currentValue;
            }

            if (
                typeof (changes.itemsLimit) !== 'undefined' &&
                !changes.itemsLimit.isFirstChange() &&
                JSON.stringify(changes.itemsLimit.currentValue) !== JSON.stringify(changes.itemsLimit.previousValue)
            ) {
                newOptions.limit = changes.itemsLimit.currentValue;
            }

            if (
                typeof (changes.maxLen) !== 'undefined' &&
                !changes.maxLen.isFirstChange() &&
                JSON.stringify(changes.maxLen.currentValue) !== JSON.stringify(changes.maxLen.previousValue)
            ) {
                newOptions.maxLen = changes.maxLen.currentValue;
            }

            if (
                typeof (changes.startWithSpace) !== 'undefined' &&
                !changes.startWithSpace.isFirstChange() &&
                JSON.stringify(changes.startWithSpace.currentValue) !== JSON.stringify(changes.startWithSpace.previousValue)
            ) {
                newOptions.startWithSpace = changes.startWithSpace.currentValue;
            }

            if (
                typeof (changes.displayTimeout) !== 'undefined' &&
                !changes.displayTimeout.isFirstChange() &&
                JSON.stringify(changes.displayTimeout.currentValue) !== JSON.stringify(changes.displayTimeout.previousValue)
            ) {
                newOptions.displayTimeout = changes.displayTimeout.currentValue;
            }

            if (
                typeof (changes.highlightFirst) !== 'undefined' &&
                !changes.highlightFirst.isFirstChange() &&
                JSON.stringify(changes.highlightFirst.currentValue) !== JSON.stringify(changes.highlightFirst.previousValue)
            ) {
                newOptions.highlightFirst = changes.highlightFirst.currentValue;
            }

            if (
                typeof (changes.delay) !== 'undefined' &&
                !changes.delay.isFirstChange() &&
                JSON.stringify(changes.delay.currentValue) !== JSON.stringify(changes.delay.previousValue)
            ) {
                newOptions.delay = changes.delay.currentValue;
            }

            if (
                typeof (changes.suffix) !== 'undefined' &&
                !changes.suffix.isFirstChange() &&
                JSON.stringify(changes.suffix.currentValue) !== JSON.stringify(changes.suffix.previousValue)
            ) {
                newOptions.suffix = changes.suffix.currentValue;
            }

            if (
                typeof (changes.hideWithoutSuffix) !== 'undefined' &&
                !changes.hideWithoutSuffix.isFirstChange() &&
                JSON.stringify(changes.hideWithoutSuffix.currentValue) !== JSON.stringify(changes.hideWithoutSuffix.previousValue)
            ) {
                newOptions.hideWithoutSuffix = changes.hideWithoutSuffix.currentValue;
            }

            if (
                typeof (changes.dataAttributes) !== 'undefined' &&
                !changes.dataAttributes.isFirstChange() &&
                JSON.stringify(changes.dataAttributes.currentValue) !== JSON.stringify(changes.dataAttributes.previousValue)
            ) {
                newOptions.editableAtwhoQueryAttrs = changes.dataAttributes.currentValue;
            }

            if (
                typeof (changes.callbacks) !== 'undefined' &&
                !changes.callbacks.isFirstChange() &&
                JSON.stringify(changes.callbacks.currentValue) !== JSON.stringify(changes.callbacks.previousValue)
            ) {
                harriOptions.callbacks = changes.callbacks.currentValue;
            }

            if (
                typeof (changes.isTextArea) !== 'undefined' &&
                !changes.isTextArea.isFirstChange() &&
                JSON.stringify(changes.isTextArea.currentValue) !== JSON.stringify(changes.isTextArea.previousValue)
            ) {
                harriOptions.isTextArea = changes.isTextArea.currentValue;
            }

            if (
                typeof (changes.disabledField) !== 'undefined' &&
                !changes.disabledField.isFirstChange() &&
                JSON.stringify(changes.disabledField.currentValue) !== JSON.stringify(changes.disabledField.previousValue)
            ) {
                harriOptions.disabledField = changes.disabledField.currentValue;
            }

            if (
                typeof (changes.leftBrackets) !== 'undefined' &&
                !changes.leftBrackets.isFirstChange() &&
                JSON.stringify(changes.leftBrackets.currentValue) !== JSON.stringify(changes.isTextArea.previousValue)
            ) {
                harriOptions.leftBrackets = changes.leftBrackets.currentValue;
            }

            if (
                typeof (changes.rightBrackets) !== 'undefined' &&
                !changes.rightBrackets.isFirstChange() &&
                JSON.stringify(changes.rightBrackets.currentValue) !== JSON.stringify(changes.rightBrackets.previousValue)
            ) {
                harriOptions.rightBrackets = changes.rightBrackets.currentValue;
            }

            if (
                typeof (changes.hideBrackets) !== 'undefined' &&
                !changes.hideBrackets.isFirstChange() &&
                JSON.stringify(changes.hideBrackets.currentValue) !== JSON.stringify(changes.hideBrackets.previousValue)
            ) {
                harriOptions.hideBrackets = changes.hideBrackets.currentValue;
            }

            if (
                typeof (changes.insertedKey) !== 'undefined' &&
                !changes.insertedKey.isFirstChange() &&
                JSON.stringify(changes.insertedKey.currentValue) !== JSON.stringify(changes.insertedKey.previousValue)
            ) {
                harriOptions.insertedKey = changes.insertedKey.currentValue;
            }

            var modelChanged;

            if (
                typeof (changes.ngModel) !== 'undefined' &&
                !changes.ngModel.isFirstChange() &&
                JSON.stringify(changes.ngModel.currentValue) !== JSON.stringify(changes.ngModel.previousValue)
            ) {
                if (!self.lockChanges) {
                    self.ngModel = changes.ngModel.currentValue;
                    modelChanged = true;
                }
            }

            var thereIsData = (newOptions.data && newOptions.data.length) || (atWhoOptions.data && atWhoOptions.data.length);

            if (
                thereIsData &&
                (
                    JSON.stringify(newOptions) !== JSON.stringify(atWhoOptions) ||
                    modelChanged
                )
            ) {
                atWhoOptions = jQuery.extend(true, atWhoOptions, newOptions);
                if (!self.lockChanges) {
                    onInit();
                }
            }
        };

        /**
         * Make sure to destroy every not needed attached things
         */
        self.$onDestroy = function () {
            if (!isDestroyed) {
                atWhoWrapper && atWhoWrapper.destroy();
                atWhoOptions = {};
                atWhoWrapper = null;

                if (element) {
                    element.remove();
                    element = null;
                }

                id = null;
                isDestroyed = true;
            }
        };

        /**
         * This need to clear data when the element removed from dom
         */
        $element.on('$destroy', function () {
            self.$onDestroy();
        });
    };

    /**
     *
     * @type {Object}
     * @name AtWhoWrapperComponent#
     */
    var AtWhoWrapperComponent = {
        bindings: {
            name: '@',
            hName: '@',
            class: '<',
            isTextArea: '<',
            character: '<',
            popupHeader: '<',
            popUpItemTemplate: '<',
            insertItem: '<',
            searchKey: '<',
            maxLen: '<',
            startWithSpace: '<',
            itemsLimit: '<',
            displayTimeout: '<',
            delay: '<',
            suffix: '<',
            highlightFirst: '<',
            data: '<',
            hideWithoutSuffix: '<',
            dataAttributes: '<',
            callbacks: '<',
            leftBrackets: '<',
            rightBrackets: '<',
            hideBrackets: '<',
            ngModel: '<',
            insertedKey: '<',
            placeHolder: '<',
            disabledField: '<',
            onModelChanged: '&'
        },
        transclude: true,
        templateUrl: '../modules/smart-fields/components/at-who-wrapper/at-who-wrapper.ng.html',
        controller: ['$scope', '$element', '$timeout','$sce','$sanitize', AtWhoWrapperComponentController],
        controllerAs: 'AtWho'
    };

    app.component('smartField', AtWhoWrapperComponent);
})(angular.module('harriApp.smartFields'));
